import { useCallback, useEffect, useState } from "react";
import camelcase from "camel-case";

import sdk from "src/sdk";

export const handleCurrentState = async (
  data,
  { forgotFlowState, setForgotFlowState }
) => {
  switch (forgotFlowState.state) {
    case "entry": {
      const result = await sdk.forgotUsername(data);

      const {
        data: { state, availableChannels },
        links,
      } = result;

      setForgotFlowState({
        state: camelcase(state),
        availableChannels,
        links,
      });

      break;
    }
    case "selectChannel": {
      const result = await sdk.selectChannelChallengeQuestionReset(
        data.userChannelId,
        {
          path: forgotFlowState.links[forgotFlowState.state],
        }
      );

      setForgotFlowState({
        ...forgotFlowState,
        state: "forgotChallengeQuestionsComplete",
      });

      break;
    }
    default:
      return;
  }
};



// WEBPACK FOOTER //
// ./src/banking/authentication/ForgotFlow/ForgotLogin/ForgotUsername/handleCurrentState.js